import * as React from "react";

import type { RuntimeTheme } from "../../../lib/theme/theme";
import { withTheme } from "styled-components";
import { CancelIcon } from "../../../media/icons";

import {
    SearchBarContainerStyle,
    SearchBarStyle,
    SearchIcon,
    SearchBarInputStyle,
    CloseButtonWrapper,
} from "./search-bar-style";

interface Props {
    value?: string;
    placeholder: string;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    onClear?(): void;
    theme: RuntimeTheme;
}

interface State {
    value: string;
    fromState: boolean;
}

class SearchBar extends React.PureComponent<Props, State> {
    public state: State = {
        value: "",
        fromState: false,
    };

    constructor(props: Props) {
        super(props);
        if (props.value !== undefined) {
            this.state.value = props.value;
        }
    }

    public static getDerivedStateFromProps(props: any, state: State) {
        const newValue = props.value ?? "";
        if (state.value !== newValue && !state.fromState) {
            state.value = newValue;
        } else if (state.fromState) {
            state.fromState = false;
        }

        return state;
    }

    private onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ value: e.currentTarget.value, fromState: true });
        this.props.onChange(e);
    };

    public render(): React.ReactNode {
        const { placeholder, onClear, theme } = this.props;
        const { value } = this.state;

        const isInline = theme.searchBar.style === "Inline";
        return (
            <SearchBarContainerStyle data-test="app-search-bar">
                <SearchBarStyle>
                    <SearchIcon />
                    <SearchBarInputStyle
                        aria-label={"Search"}
                        role="search"
                        placeholder={placeholder}
                        value={value}
                        onChange={this.onChange}
                        autoFocus={!isInline}
                    />
                    {value !== undefined && value.length > 0 && isInline ? (
                        <CloseButtonWrapper onClick={onClear}>
                            <CancelIcon />
                        </CloseButtonWrapper>
                    ) : undefined}
                </SearchBarStyle>
            </SearchBarContainerStyle>
        );
    }
}

export default withTheme(SearchBar);
